<div
    class="fw-bold"
    [class.text-danger-emphasis]="quantity().isOverInvoiced"
    [class.text-success-emphasis]="quantity().isFullyInvoiced"
    [class.text-info-emphasis]="!quantity().isOverInvoiced && !quantity().isFullyInvoiced"
>
    @if (quantity().isOverInvoiced) {
        {{ quantity().overInvoicedQuantity | number: '1.0-3' }} {{ unit() }}
        {{ 'zu viel abgerechnet' | translate }}
    } @else if (quantity().isFullyInvoiced) {
        {{ 'Vollständig abgerechnet' | translate }}
    } @else {
        {{ 'Teilrechnung' | translate }} · {{ quantity().openQuantity | number: '1.0-3' }} {{ unit() }}
        {{ 'offen' | translate }}
    }
</div>
<div class="invoiced-bar mt-1" aria-hidden="true">
    @if (quantity().isOverInvoiced) {
        <span class="invoiced-bar-ordered" [style.width.%]="100 - quantity().overInvoicedPercent"></span>
        <span class="invoiced-bar-over" [style.width.%]="quantity().overInvoicedPercent"></span>
    } @else if (quantity().isFullyInvoiced) {
        <span class="invoiced-bar-ordered" [style.width.%]="100"></span>
    } @else {
        <span class="invoiced-bar-partial" [style.width.%]="quantity().invoicedPercent"></span>
    }
</div>
